import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { ConfirmDialogData } from '../../dialog/confirm/confirm.component';
import { ToastService } from '@app/services/toast.service';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule, DatePipe, NgFor, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DialogService } from '../../../../services/dialog.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Global from '../../../../global';
import { FileDragNDropDirective } from '../../../../directives/file-drag-drop.directive';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExpenseService } from '../../../../services/expense.service';
import { CameraComponent } from './camera/camera.component';
import { HelpersService } from '../../../../services/helpers.service';
@Component({
  selector: 'app-multi-attachment',
  standalone: true,
  imports: [
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    NgFor,
    NgIf,
    MatIconModule,
    MatButtonModule,
    FileDragNDropDirective,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    DatePipe,
    CommonModule,
  ],
  templateUrl: './multi-attachment.component.html',
  styleUrl: './multi-attachment.component.scss',
})
export class MultiAttachmentComponent {
  viewport: any = {
    height: 500,
    width: 500,
  };
  Global = Global;
  formGroup!: FormGroup;
  showAddMore: boolean = false;
  @ViewChild('fileInput') fileInput!: ElementRef;
  folderPath: string = '/Attachments/'
  allowedTypes: Array<string> = [
    'application/pdf',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/jpeg',
    'image/png',
  ];
  constructor(
    public toastr: ToastService,
    public dialogService: DialogService,
    public expenseService: ExpenseService,
    public spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private helpers: HelpersService,
    public dialogRef: MatDialogRef<MultiAttachmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) {
    if (this.data?.allowedTypes?.length) {
      this.allowedTypes = this.data?.allowedTypes ?? []
    }
    if (this.data?.folderPath) {
      this.folderPath = this.data.folderPath
    }
    this.helpers.viewport$.subscribe((data) => {
      if (data) {
        this.viewport = data;
      }
    });
    this.formGroup = this.fb.group({
      attachments: this.fb.array([]),
    });
    if (this.data.values?.length) {
      this.data.values.forEach((existing_file: any) => {
        this.attachments.push(this.newAttachment(existing_file));
      });
    }
  }
  get attachments(): FormArray {
    return this.formGroup.get('attachments') as FormArray;
  }
  newAttachment(item: any) {
    return this.fb.group({
      receiptName: [
        item?.receiptName ?? null,
        Validators.compose([Validators.required]),
      ],
      receiptPath: [
        item?.receiptPath ?? null,
        Validators.compose([Validators.required]),
      ],
    });
  }
  onSave(): void {
    this.dialogRef.close({
      attachments: this.formGroup.value.attachments,
      data: this.data,
    });
  }

  onCancel(): void {
    this.dialogRef.close({
      attachments: [],
      data: this.data,
    });
  }
  closeModal() {
    this.dialogRef.close({
      // attachments: [],
      // data: this.data,
    });
  }
  onBrowseFile(event: any): void {


    if (event.target.files.length > 0) {
      const maxSize: number = 5000000; // Default max size is 5MB
      const files = event.target.files;

      // Store the component instance in a variable
      const self = this;
      this.attachments.clear();

      for (let index = 0; index < files.length; index++) {
        const file = files[index];

        if (file.size > maxSize) {
          this.toastr.error('File size exceeds the limit');
          continue; // Skip this file and continue with the next one
        }
        // Check file type
        if (!this.allowedTypes.includes(file.type)) {
          this.toastr.error('File type is not allowed');
          continue; // Skip this file and continue with the next one
        }

        const reader = new FileReader();

        reader.onloadend = () => {
          // Use arrow function to preserve 'this'
          let fileData = {
            receiptName: file.name,
            receiptPath: reader.result,
          };
          if (fileData?.receiptPath) {
            self.attachments.push(
              self.newAttachment({
                receiptName: file.name,
                receiptPath: reader.result,
              })
            );
          }
        };

        reader.onerror = () => {
          // Error handling for FileReader
          console.error('Error reading file:', reader.error);
        };

        reader.readAsDataURL(file);
      }
    }
  }

  removeAttachment(index: number) {
    this.attachments.removeAt(index);
  }
  downloadFile(base64: string, fileName: string) {
    if (Global.isImage(fileName)) {
    } else {
      const src = base64; // Adjust the MIME type according to your file type
      const link = document.createElement('a');
      link.href = src;
      link.download = fileName;
      link.click();
      link.remove();
    }
  }
  deleteAttachment(item: any, index: number) {
    const dialogData: ConfirmDialogData = {
      title: 'Are you sure?',
      message: `You want to delete this attachment?`,
      saveText: `Confirm`,
      cancelText: 'Cancel',
      type: 'danger',
    };
    this.dialogService.confirmDialog(dialogData).subscribe((result: any) => {
      if (result?.confirm) {
        if (this.data?.delete == 'local-conveyance') {
          this.spinner.show();
          this.expenseService
            .deleteLocalConveyanceExpenseDocument(item.id)
            .subscribe({
              next: (res) => {
                this.toastr.success(`Expense Attachment Deleted Successfully`);
                this.data.existing.splice(index, 1);
              },
              error: (err) => {
                this.spinner.hide();
              },
              complete: () => {
                this.spinner.hide();
              },
            });
        } else if (this.data?.delete == 'car-bike-log') {
          this.spinner.show();
          this.expenseService
            .deleteCarBikeLogBookExpenseDocument(item.id)
            .subscribe({
              next: (res) => {
                this.toastr.success(`Expense Attachment Deleted Successfully`);
                this.data.existing.splice(index, 1);
              },
              error: (err) => {
                this.spinner.hide();
              },
              complete: () => {
                this.spinner.hide();
              },
            });
        } else {
          this.spinner.show();
          this.expenseService.deleteExpenseDocument(item.id).subscribe({
            next: (res) => {
              this.toastr.success(`Expense Attachment Deleted Successfully`);
              this.data.existing.splice(index, 1);
            },
            error: (err) => {
              this.spinner.hide();
            },
            complete: () => {
              this.spinner.hide();
            },
          });
        }
      }
    });
  }
  onFileChange(event: any, type: string) {

    let files = [];
    if (type == 'choose') {
      files = event.target.files;
    }
    if (type == 'drag') {
      files = event;
    }
    if (type == 'paste') {
      files = [event];
    }

    if (files?.length > 0) {
      const maxSize: number = 5000000; // Default max size is 5MB

      // Store the component instance in a variable
      const self = this;
      // this.attachments.clear();
      if (!this.data.multi) {
        files = [files[0]];
      }
      for (let index = 0; index < files.length; index++) {
        const file = files[index];

        if (file.size > maxSize) {
          this.toastr.error('File size exceeds the limit');
          continue; // Skip this file and continue with the next one
        }
        // Check file type
        if (!this.allowedTypes.includes(file.type)) {
          this.toastr.error('File type is not allowed', file.name);
          continue; // Skip this file and continue with the next one
        }

        const reader = new FileReader();

        reader.onloadend = () => {
          // Use arrow function to preserve 'this'
          let fileData = {
            receiptName: file.name,
            receiptPath: reader.result,
          };
          if (fileData?.receiptPath) {
            self.attachments.push(
              self.newAttachment({
                receiptName: file.name,
                receiptPath: reader.result,
              })
            );
          }
        };

        reader.onerror = () => {
          // Error handling for FileReader
          console.error('Error reading file:', reader.error);
        };

        reader.readAsDataURL(file);
      }
      this.showAddMore = false;
    }
  }
  onPaste(e: any) {
    const items = (e.clipboardData || e.originalEvent.clipboardData).items;
    let blob = null;
    for (const item of items) {
      if (item.type.indexOf('image') === 0) {
        blob = item.getAsFile();
        this.onFileChange(blob, 'paste');
      }
    }
  }
  addMore() {
    this.showAddMore = !this.showAddMore;
  }
  pickFile() {
    this.fileInput.nativeElement.click();
  }
  toTitleCase(camelCaseString: string) {
    // Split the string into words based on the transition from lowercase to uppercase letters
    const words = camelCaseString.split(/(?=[A-Z])/);

    // Capitalize the first letter of each word and join them with spaces
    const titleCaseWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    );

    return titleCaseWords.join(' ');
  }
  takePicture() {
    this.dialog
      .open(CameraComponent)
      .afterClosed()
      .subscribe((imageData: any) => {
        if (imageData) {
          this.onFileChange(imageData, 'paste');
        }
      });
  }
}
